define('modules/reporting/campaigns/dataExport/createEdit/views/columnSelector',["T1ColumnSortable"], function (ColumnSortable) {
  "use strict";

  return ColumnSortable;
});
